$(document).ready(function() {
  
    $('.banner-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 2000,
    });

  $('.section-featured-products .product-highlights-normal-wrapper').owlCarousel({
      loop:true,
      margin:0,
      autoplay:false,
      autoplayTimeout:5000,
      slideSpeed: 300,
      smartSpeed: 1500,
      nav:true,
      dots:false,
      responsive:{
        0:{
          items:1
        },
        480:{
          items:2
        },
        992:{
          items:3
        },
        1025:{
          items:4
        }
      }
    });
  
  // $('.section-featured-products .product-highlights-normal-wrapper').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 575,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  $('.product_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  


   $('.product-gallery .slider-for').slick({
        slidesToShow: 1,
        infinite: false,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        adaptiveHeight:true,
       swipeToSlide: false,
       swipe:false,
        asNavFor: '.product-gallery .slider-nav'
      });
      $('.product-gallery .slider-nav').slick({
        slidesToShow: 4,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        asNavFor: '.product-gallery .slider-for',
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      });  
      

   
  });